var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgBoxGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 81,
    viewBox: "0 0 312 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_9",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 312,
    height: 81
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 312,
    height: 81,
    fill: "#C6F9E4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 312,
    height: 81,
    fill: "url(#paint0_linear_2_9)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_9)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 312,
    height: 81,
    fill: "#C6F9E4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 312,
    height: 81,
    fill: "url(#paint1_linear_2_9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.364 62.721V72H324.182V81H271.818V72H293.636V62.721C285.2 61.6239 277.442 57.3897 271.818 50.8129C266.194 44.236 263.091 35.7687 263.091 27V0H332.909V27C332.909 35.7687 329.806 44.236 324.182 50.8129C318.558 57.3897 310.8 61.6239 302.364 62.721V62.721ZM271.818 9V27C271.818 34.1608 274.577 41.0284 279.487 46.0919C284.397 51.1554 291.056 54 298 54C304.944 54 311.603 51.1554 316.513 46.0919C321.423 41.0284 324.182 34.1608 324.182 27V9H271.818ZM250 9H258.727V27H250V9ZM337.273 9H346V27H337.273V9Z",
    fill: "white",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_9",
    x1: 9.86207,
    y1: 63,
    x2: 313.738,
    y2: 49.7508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EA26B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06ED8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_9",
    x1: 9.86207,
    y1: 63,
    x2: 313.738,
    y2: 49.7508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EA26B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06ED8D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgBoxGreen);
export default __webpack_public_path__ + "static/media/bg-box-green.153bb8270b082f83be0f1e4f48c8a8f4.svg";
export { ForwardRef as ReactComponent };